import { defineComponent, PropType } from 'vue'
import './index.scss'
import { AspectRatio, BaseCardSwiper, GfrContainer, ModuleBase, ModuleBaseHeader, NuxtLink } from '#components'
import { moduleBaseProps } from '@/components/module/base'
interface NewsItem {
  title: string
  tag?: string
  image: string
  publish_time: number
  weight: number
  url: string
  display: number // 前端过滤 0 ｜ 1
}
export default defineComponent({
  name: 'ModuleHomeScreen2',
  props: {
    ...moduleBaseProps,
    title: String,
    list: {
      type: Array as PropType<NewsItem[]>,
      default: () => []
    }
  },
  setup(props, { slots }) {
    const newsList = computed(() => {
      return props.list.filter((item) => item.display === 1).sort((a, b) => b.weight - a.weight)
    })
    return () => (
      <ModuleBase name={props.name} class={'module-home-news-base'}>
        <GfrContainer class="module-home-news">
          <ModuleBaseHeader decoration={false} title={props.title} />
          <BaseCardSwiper class="mt-6 w-full" slides={newsList.value.slice(0, 3)} />
        </GfrContainer>
      </ModuleBase>
    )
  }
})
